import axios from '../utils/axios';

export default function fetchCourseByIntegration(adminId, integrationId, params = {}) {
    
    return axios.get(`/admin/${adminId}/courses/integrations/${integrationId}/courses`, { params });
}